import {Injectable} from '@angular/core';
import {environment} from './../../../environments/environment';
import {ParamService} from './param.service';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UcaNavigationService {
    banner: string;
    populateUcaNavigationSource$ = new BehaviorSubject(null);

    constructor(
        private paramService: ParamService,
        private http: HttpClient) {
        this.banner = this.paramService.banner;
    }

    getWindow(): any {
        return window;
    }

    getApplicationDomainURL() {
        let domain;
        if (window.location.href.indexOf('local') > 0) {
            domain = 'https://www-qa1.' + this.banner + '.com';
        } else {
            domain = 'https://' + window.location.host;
        }
        return domain;
    }

    getLeftNavItems() {
        let url = '';
        url = this.getApplicationDomainURL() + environment.Left_NAV_API_V2;
        url = url.replace(/\{banner\}/g, this.banner);
        this.http.get(`${url}`).subscribe((response: any) => {
                if (response) {
                    this.populateUcaNavigationSource$.next(response);
                }
            },
            error => {
                console.log('Error while fetching navigation from UCA');
            });
    }

}
